import { Skeleton } from 'components/ui/skeleton';

export type SkeletonMessagesProps = {
  numberOfTupleMessages?: number;
};

export default function SkeletonMessages(props: SkeletonMessagesProps = { numberOfTupleMessages: 1 }) {
  const { numberOfTupleMessages } = props;

  const renderMessageLeft = () => (
    <div className="flex items-center gap-2">
      <Skeleton className="size-8 shrink-0 rounded-full" />
      <Skeleton className="h-10 w-40" />
    </div>
  );
  const renderMessageRight = () => (
    <div className="flex items-center justify-end gap-2">
      <Skeleton className="h-10 w-40" />
      <Skeleton className="size-8 shrink-0 rounded-full" />
    </div>
  );

  const renderTupleMessages = (key: string) => (
    <div key={key} className="flex flex-col gap-4">
      {renderMessageLeft()}
      {renderMessageRight()}
    </div>
  );

  return (
    <div className="flex-1 bg-background">
      <div className="grid gap-4 p-5">
        {[...Array(numberOfTupleMessages)].map((value, index) => renderTupleMessages(`skeleton-message-${index}`))}
      </div>
    </div>
  );
}
